import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import isDefined from '@afosto/utils/isDefined';
import resizeImageUrl from '@afosto/utils/resizeImageUrl';
import Typography from '@material-ui/core/Typography';

const CalculationInvoiceItem = ({ item, onClick }) => {
  const hasDescription = isDefined(item.description);

  const handleClick = () => {
    if (onClick && typeof onClick === 'function') {
      onClick(item);
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <ListItem onClick={handleClick} button={!!onClick}>
        <ListItemAvatar>
          <Avatar alt={item.description} src={resizeImageUrl(item?.image, 50)} />
        </ListItemAvatar>
        <ListItemText
          primary={hasDescription ? item.description : item.sku}
          secondary={
            <>
              {hasDescription && <Typography variant="body2">{item.sku}</Typography>}
              <Typography variant="body2">{item.quantity}x</Typography>
            </>
          }
        />
      </ListItem>
    </Box>
  );
};

CalculationInvoiceItem.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

CalculationInvoiceItem.defaultProps = {
  onClick: undefined,
};

export default CalculationInvoiceItem;
